import angular from 'angular';
import projectGroupService from './project-group.service';
import projectService from './project.service';
import teamService from './team.service';
import userInGroupService from './user-in-group.service';
import userInTeamService from './user-in-team.service';
import userInProjectService from './user-in-project.service';
import filterStorageService from './filter-storage.service';

const configuration = angular.module('ttb.services.configuration', [
  projectGroupService,
  projectService,
  teamService,
  userInGroupService,
  userInTeamService,
  userInProjectService,
  filterStorageService,
])
  .name;

export default configuration;



// WEBPACK FOOTER //
// ../services/configuration/index.js